import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Montserrat, Pixelify_Sans } from 'next/font/google'

const sans = Montserrat({
    subsets: ['latin']
})

const heading = Pixelify_Sans({
    subsets: ['latin']
})

const monoStack = 'ui-monospace, SFMono-Regular, Menlo, monospace'

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${monoStack};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
